"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, switchMap, catchError, map } from "rxjs/operators";

import { requestTypes } from "../_constants";
import { lcvReportsConstants } from "../_constants/lcvReports.constants";
import {
     lcvReportsGetDealersComplete,
     lcvReportsGetDealersExportComplete,
     lcvReportsGetGamesComplete,
     lcvReportsGetGamesExportComplete,
     lcvReportsGetFilterOptionsComplete,
} from "../_actions/lcvReports.action";
import { ajaxError } from "../_actions";
import { getRequestHeader } from "../../_helpers/request.header";
import { withLcvCampaign } from "./lcvCampaign.epic";

// A grid read uses switchMap so the newest set of criteria wins and an older page never lands on
// top of it. A download uses mergeMap because it is the user asking for one specific file and
// cancelling it would leave the button spinning.
const post = (url, complete, operator, state$) =>
     operator((incoming) =>
          ajax
               .post(url, withLcvCampaign(incoming.payload, state$), getRequestHeader(requestTypes.REQUEST_TYPE_POST))
               .pipe(
                    map((ajaxResponse) => complete(ajaxResponse.response)),
                    catchError((error) => of(ajaxError(error))),
               ),
     );

export const lcvReportsGetDealersEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvReportsConstants.LCV_REPORTS_GET_DEALERS_REQUEST),
          post("/api/lcvReports/getDealers", lcvReportsGetDealersComplete, switchMap, state$),
     );
};

export const lcvReportsGetDealersExportEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvReportsConstants.LCV_REPORTS_GET_DEALERS_EXPORT_REQUEST),
          post("/api/lcvReports/getDealersExport", lcvReportsGetDealersExportComplete, mergeMap, state$),
     );
};

export const lcvReportsGetGamesEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvReportsConstants.LCV_REPORTS_GET_GAMES_REQUEST),
          post("/api/lcvReports/getGames", lcvReportsGetGamesComplete, switchMap, state$),
     );
};

export const lcvReportsGetGamesExportEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvReportsConstants.LCV_REPORTS_GET_GAMES_EXPORT_REQUEST),
          post("/api/lcvReports/getGamesExport", lcvReportsGetGamesExportComplete, mergeMap, state$),
     );
};

export const lcvReportsGetFilterOptionsEpic = (actions$, state$) => {
     return actions$.pipe(
          ofType(lcvReportsConstants.LCV_REPORTS_GET_FILTER_OPTIONS_REQUEST),
          post("/api/lcvReports/getFilterOptions", lcvReportsGetFilterOptionsComplete, switchMap, state$),
     );
};
